<div class="header">
	<div class="block-1" [routerLink]="['/']">
		<mat-icon class="icon" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="block-2">
		<a href="javascript:void(0)"><img src="./assets/images/header/h-google.png" alt="Google Icon"></a>
		<a href="javascript:void(0)"><img src="./assets/images/header/h-apple.png" alt="App Store Icon"></a>
	</div>
</div>
<div id="login-container">
	<div class="form">
		<div class="titles">
			<h3 class="reset-password">OTP Verification!</h3>
			<p class="message">Enter OTP code and confirm then reset your password</p>
		</div>

		<div class="input-container">
			<div class="form-group">
				<label>OTP<sup class="error">*</sup></label>
				<ng-otp-input #ngOtpInput (onInputChange)="doLogin($event)" [config]="otpConfig"></ng-otp-input>
				<div class="col-12 text-center resend-otp-block">
					<!-- <a class="small" href="javascript:void(0)" (click)="doResendOtp()">Resend OTP?</a> -->
					<span *ngIf="isTimerActive">
						<span style="color: black;font-weight: 300;"> Don't receive OTP?</span> &nbsp; Resend in {{
						resendOtpTimer }} seconds
					</span>
					<a class="small" href="javascript:void(0)" *ngIf="!isTimerActive" (click)="doResendOtp()">
						Resend OTP?
					</a>
				</div>
			</div>
		</div>
	</div>
	<div class="image-container">
		<img src="assets/images/side-image-2.png" alt="brand-image" />
	</div>
</div>
<div class="footer">
	<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 px-0">
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 block-1">
			<p>Already have account?
				<a href="javascript:void(0)" [routerLink]="['/login']">
					<strong>&nbsp;Login</strong>
				</a>
			</p>
		</div>
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 text-right block-2">
			<a [routerLink]="['/termsandconditions']">Terms & Conditions</a>
			<span>|</span>
			<a [routerLink]="['/privacypolicy']">Privacy Policy</a>
		</div>
	</div>
</div>